import { BewareFormVM, TableBewareVM } from 'mutation/view-models/registration-beware';
import { HeadCell } from 'shell/components/shared/table/types';
import { regexOnlyNumber } from 'shell/constants/regex';
import * as yup from 'yup';

export const headCells: HeadCell<TableBewareVM, keyof TableBewareVM>[] = [
  {
    id: 'type',
    label: 'Tipo',
  },
  {
    id: 'from',
    label: 'Dal',
  },
  {
    id: 'to',
    label: 'Al',
  },
  {
    id: 'note',
    label: 'Note',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

export const headCellsWithoutAction: HeadCell<TableBewareVM, keyof TableBewareVM>[] = [
  {
    id: 'type',
    label: 'Tipo',
  },
  {
    id: 'from',
    label: 'Dal',
  },
  {
    id: 'to',
    label: 'Al',
  },
  {
    id: 'note',
    label: 'Note',
  },
];

export const validationSchema = yup
  .object()
  .shape({
    typology: yup.string().nullable().required('Il campo è obbligatorio'),
    // italian
    municipalityItalian: yup.object().nullable().shape({
      description: yup.string().nullable(),
    }),
    dateForm: yup
      .date()
      .typeError('Data non valida')
      .nullable()
      .required('Il campo è obbligatorio'),
    year: yup
      .string()
      .nullable()
      .required('Il campo è obbligatorio')
      .matches(regexOnlyNumber, 'Campo numerico'),

    note: yup.string().nullable().required('Il campo è obbligatorio'),
  })
  .test('municipalityItalian.description', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as BewareFormVM;

    if (!castedValues?.isForeign && !castedValues?.municipalityItalian?.description) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'municipalityItalian.description'
      );
    }

    return true;
  });
